import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { notification } from "antd";

import { routeLogin } from "routes/pages";
import { endpointStatesOfCountry } from "../services/endpoints";

import { API_URL_HERU, API_URL_HERU_NEW_GATEWAY } from "constants/apis";

export function getTokenCookie(): string | undefined {
  return document.cookie.split("; ")?.find((item) => item.includes("token"));
}

export function getTokenCookieValue(): string | null {
  try {
    const supabaseKeys = Object.keys(localStorage).filter(key =>
      key.startsWith('sb-') && key.includes('-auth-token')
    );
    
    if (supabaseKeys.length > 0) {
      const authData = localStorage.getItem(supabaseKeys[0]);
      if (authData) {
        const parsed = JSON.parse(authData);
        const accessToken = parsed?.access_token;
        if (accessToken) {
          return accessToken;
        }
      }
    }
  } catch (error) {
    console.error('Error getting Supabase token:', error);
  }
  
  const tokenCookie = getTokenCookie();
  return !!tokenCookie ? tokenCookie?.split("=")[1] ?? null : null;
}

export function setTokenCookie({ token, maxAge }: { token: string; maxAge: number }): void {
  document.cookie = `token=${token}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

export function deleteTokenCookie(): void {
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export const apiHeru = axios.create({ baseURL: API_URL_HERU });
export const newApiHeru = axios.create({ baseURL: API_URL_HERU_NEW_GATEWAY });

export const setAuthorizationInDefaultCommonHeaderToApiHeru = (value: string | undefined): void => {
  apiHeru.defaults.headers.common["Authorization"] = value;
  newApiHeru.defaults.headers.common["Authorization"] = value;
};

apiHeru.interceptors.request.use(
  (configuration) => {
    let newConfig = null;
    const tokenValue = getTokenCookieValue();
    if (!!tokenValue && configuration?.url !== "/login" && !configuration?.headers?.common?.Authorization) {
      newConfig = {
        ...configuration,
        headers: { Authorization: `Bearer ${tokenValue}` },
      };
    }
    return newConfig ?? configuration;
  },
  (error) => Promise.reject(error),
);

newApiHeru.interceptors.request.use(
  (configuration) => {
    let newConfig = null;
    const tokenValue = getTokenCookieValue();
    if (!!tokenValue && configuration?.url !== "/login" && !configuration?.headers?.common?.Authorization) {
      newConfig = {
        ...configuration,
        headers: { Authorization: `Bearer ${tokenValue}` },
      };
    }
    return newConfig ?? configuration;
  },
  (error) => Promise.reject(error),
);

// Response interceptor for old API
(function () {
  apiHeru.interceptors.response.use(
    (response) => response,
    async (error) => {
      const internalCode = error?.response?.data?.internal_code;
      if ([1100, 1200, 1201, 1202, 1203].includes(internalCode)) {
        showMessageByErrorToken();
      }
      return Promise.reject(error);
    },
  );
})();

(function () {
  newApiHeru.interceptors.response.use(
    (response) => response,
    async (error) => {
      const internalCode = error?.response?.data?.internal_code;
      if ([1100, 1200, 1201, 1202, 1203].includes(internalCode)) {
        showMessageByErrorToken();
      }
      return Promise.reject(error);
    },
  );
})();

function showMessageByErrorToken(): void {
  notification.error({
    duration: 5,
    message: "Sesión Finalizada",
    description: "Por seguridad la sesión ha finalizado, vuelve a ingresar cuando lo necesites.",
    onClose: (): void => {
      deleteTokenCookie();
      window.location.replace(routeLogin());
    },
  });
}

export function filtersToQueryString(filters = {}): string {
  const queryString = Object.entries(filters)
    .map((query): string => `${query[0]}=${query[1]}`)
    .join("&");
  return queryString.length ? "?" + queryString : "";
}

export function extractQueryString(url): string | undefined {
  return url.match("[?].*")?.[0];
}

interface ItfFnFetchData {
  config: AxiosRequestConfig;
  instance?: AxiosInstance;
  isPagination?: boolean;
  callbackSuccess?: (d: any) => void;
}

export async function fnFetchData(params?: ItfFnFetchData) {
  const {
    instance = apiHeru,
    config = { url: endpointStatesOfCountry() },
    isPagination = false,
    callbackSuccess = (d) => d,
  }: ItfFnFetchData = params;
  try {
    const { data } = await instance({ method: "GET", ...config });
    if (!isPagination) return callbackSuccess(data?.resource || data);
    if (isPagination) return callbackSuccess({ list: data?.resource, pagination: data?.pagination });
  } catch (err) {
    throw err?.response?.data || err?.response || "Error inesperado...";
  }
}

export async function fnFetchDataNewGateway(params?: ItfFnFetchData) {
  const {
    instance = newApiHeru,
    config = { url: endpointStatesOfCountry() },
    isPagination = false,
    callbackSuccess = (d) => d,
  }: ItfFnFetchData = params;
  try {
    const { data } = await instance({ method: "GET", ...config });
    if (!isPagination) return callbackSuccess(data?.resource || data);
    if (isPagination) return callbackSuccess({ list: data?.resource, pagination: data?.pagination });
  } catch (err) {
    throw err?.response?.data || err?.response || "Error inesperado...";
  }
}